import React, { memo, useMemo } from "react"
import Money from "../../../../../helpers/utils/money/money"
import useDarkMode from "../../../../../hooks/useDarkMode";
import TableCustomCmv from "../../../../../components/MyCustom/TableCustomCmv";
import useCmvHistory from "../../../../../hooks/reports/useCmvHistory";
import { getFloatCMV, getMediumPriceCMV, getTotalMediumPrice } from "../../../../../utils/cmv/convertQtd";
import Spinner from "../../../../../components/bootstrap/Spinner";

const TabEntradaHistorico = ({ hidden, dataFilter }) => {
    const { darkModeStatus } = useDarkMode()
    const { entry, loading } = useCmvHistory(dataFilter)

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, '0');
        return [
            {
                label: `${day} - Qtd`,
                field: `{row}`,
                formatExport: (row) => row?.days[day]?.qtd ?? 0,
                hidden: true,
            },
            {
                label: `Total`,
                field: `{row}`,
                formatExport: (row) => {
                    const total = row?.days[day]?.qtd ?? 0;
                    const qtd = row?.days[day]?.price ?? 0
                    const totalPago = qtd > 0 ? total * qtd : 0;
                    return Money.centsToCoinCsv(totalPago)
                },
                hidden: true,
            }
        ];
    }).flat();





    const columns = useMemo(() => [
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'Unidade',
            field: 'unit',
        },
        ...days,
        {
            label: 'Valor médio UNIT',
            field: '{row}',
            format: row => Money.centsToMaskMoney(getMediumPriceCMV(row.priceTotal, row.qtdTotal)),
            isCurrency: true
        },
        {
            label: 'Volume Total',
            field: '{row}',
            format: row => getFloatCMV(row.qtdTotal),
        },
        {
            label: 'Valor Total',
            field: 'total',
            format: row => Money.centsToMaskMoney(row.priceTotal),
            isCurrency: true
        },
    ], [darkModeStatus, days])

    return (
        <div hidden={hidden}>
            {loading ? (
                <div className="d-flex flex-column justify-content-center align-items-center h-100">
                    <Spinner
                        className='text-center'
                        color='blue'
                        size={72}
                        tag='span'
                    />                </div>
            ) : (
                <TableCustomCmv
                    titlePdf='entrada-historico'
                    icon='TableChart'
                    fontSize={8}
                    rows={entry}
                    columns={columns}
                    fileName='Entrada-Insumo'
                    type="history"
                />
            )}


        </div>
    )
}

export default memo(TabEntradaHistorico)